import React from "react";

const DevLog2 = React.forwardRef((props, ref) => {
  const flexStyle = {
    display: "flex",
    flexWrap: "wrap",
    width: "max-content",
    maxWidth: "100%",
    minWidth: "min(20rem, 100%)",
    alignItems: "center",
  };

  const heading = "Updates to the Overworld and Characters";
  const date = "2nd March 2022";
  return (
    <div ref={ref}>
      {/* // ! Do not change positions */}
      <h1>{heading}</h1>
      <h4>{date}</h4>
      <div>
        <p>
          <strong>
            Hello everyone and welcome to our fourth Discovery Log!
          </strong>
        </p>
        <br />
        <div>
          <p>
            This week, we won’t be focusing on a single major topic but instead
            we will be focusing on smaller additions that our team wanted to
            share. We’ll be taking a look at a couple of updates that have been
            made to the Overworld along with some early models for the player
            characters and the design choices made behind them. Let’s not waste
            any more time and get right into it!
          </p>
          <br />
          <p>
            In our last Discovery Log, we took a look at the Overworld level and
            its many defining features but since that Log was published there
            have been a couple of new additions that were added to the
            Overworld.
          </p>
          <br />
          <p>
            We’ve added a fog effect to help hide the outer edges of the world
            from normal view as well as adding atmosphere and personality to the
            Overworld. The fog was brought into the Overworld thanks to our
            environment artist, Donovan De Carle.
          </p>
          <img
            src="../logImages/log4/FullOverview.jpg"
            alt="Overworld Fog"
            style={{ maxWidth: "100%", width: "auto", marginRight: "2rem" }}
          />
          <br />
          <p>
            We’ve also added some dynamic sound effects to the Overworld to give
            it some ambience. Some sound effects such as the river and waterfall
            adjust their volumes depending on how close players are to them in
            the game. The sound effects were compiled and added by Jeffrey
            Armstrong. Take a listen!
          </p>
          <br />
          <video
            src="../logImages/log4/Audio Demo_Compressed.mp4"
            controls
            autoPlay
            muted
            loop
          ></video>
          <p>
            Next, we would like to talk a little bit about the two playable
            characters of Project Steelwalker and their designs now that our art
            team have placeholder models that make the two of them distinct from
            each other.
          </p>
          <br />
          <div style={flexStyle}>
            <p
              style={{
                width: "min(40rem, 100%)",
                minWidth: "min(15rem, 100%)",
                marginRight: "auto",
              }}
            >
              The Rogue (Name Pending) has an overall design of that of a
              fantasy Rogue or Ranger and is represented by the color of purple.
              They are clad in cloth and leather, with a face mask cloak, and
              some pouches along their belt. They also sport some light armoring
              along the chest and forearms which are the only kind of protection
              that they wear.
            </p>
            <img
              src="../logImages/log4/Rogue.PNG"
              alt="Overworld Fog"
              style={{
                maxWidth: "100%",
                width: "15rem",
                marginRight: "2rem",
              }}
            />
          </div>
          <br />
          <div style={flexStyle}>
            <p
              style={{
                width: "min(40rem, 100%)",
                minWidth: "min(15rem, 100%)",
                marginRight: "auto",
              }}
            >
              The Paladin (Name Pending) has an overall design conceived of that
              of a lesser Knight or Man-at-Arms and is represented by the color
              of yellow. They wear slightly heavier metallic pieces of armor
              combined with textiles for protection. They also have a bevor to
              cover the lower half of their face as well as a colored tabard and
              bandolier.
            </p>
            <img
              src="../logImages/log4/Paladin.PNG"
              alt="Overworld Fog"
              style={{ maxWidth: "100%", width: "15rem", marginRight: "2rem" }}
            />
          </div>
          <br />
          <p>
            One of our biggest goals when designing the two playable characters
            were to differentiate them as much as possible through many
            different characteristics. For example, we wanted the Rogue to be a
            light-footed agile character in comparison to the Paladin, who we
            wanted to be a heavy duty counterpart to the Rogue’s smaller
            profile. The design of the Heirlooms also played a major role in
            these differentiations, with the choices on which character getting
            which Heirloom being based on their talents and lifestyles. We’ve
            taken every opportunity to make both the Rogue and Paladin as
            different from each other as possible, we hope you’ll enjoy playing
            as both characters!
          </p>
          <br />
          <p>
            That’s it for this week’s Discovery Log, we’ll leave you with this
            sneak preview of the topic for the next Discovery Log. Brace
            yourselves, because it’s going to be huge…
          </p>
          <br />
          <video
            src="../logImages/log4/Mech Preview.mp4"
            controls
            autoPlay
            muted
            loop
          ></video>
          <br />
          <br />- Particle Interactive
        </div>
      </div>
    </div>
  );
});

export default DevLog2;
